import {
  ImportControlModeTemplateErrorDto,
  ImportControlModeTemplateResponseDto,
} from '@src/types/ControlModes';
import useApiMutation from '@src/hooks/useApiMutation';

export enum entityName {
  STACKS = 'stacks',
  TEMPLATES = 'control-mode-templates',
}

export default function useImportFile(entityName: entityName) {
  const mutation = useApiMutation<File, ImportControlModeTemplateResponseDto>({
    apiPath: `/${entityName}/import-file`,
    method: 'POST',
    useV2API: true,
    isFileUpload: true,
  });

  const importFile = async (
    file: File,
  ): Promise<ImportControlModeTemplateResponseDto | null> => {
    return mutation.mutateAsync(file);
  };

  return {
    importFile,
    isImporting: mutation.isPending,
    error:
      (mutation.error?.cause as
        | Error
        | ImportControlModeTemplateErrorDto
        | null) || mutation.error,
  };
}
